import { Injectable } from '@angular/core';

import { ParticipantType } from '@cds/betting-offer';
import { HorseRaceSortingDirection, ParticipantFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { LocalStoreService } from '@frontend/vanilla/core';

@Injectable()
export class HorsesRaceService {
    constructor(private m2LocalStore: LocalStoreService) {}

    restoreParticipantOrder<TParticipant extends WinGameParticipant, TFixture extends ParticipantFixture<TParticipant>>(
        lastOrdered: TParticipant[],
        fixture: ParticipantFixture<TParticipant>,
    ): TParticipant[] {
        const indexHash = lastOrdered.reduce((acc: any, curr, index) => {
            acc[curr.id] = index + 1;

            return acc;
        }, {});

        return [...fixture.participants].sort((a, b) => {
            const favoritesSort = this.favoriteSortingWeight(a) - this.favoriteSortingWeight(b);
            if (favoritesSort !== 0) {
                return favoritesSort;
            }

            return (indexHash[a.id] || Number.MAX_SAFE_INTEGER) - (indexHash[b.id] || Number.MAX_SAFE_INTEGER);
        });
    }

    getSortingDirection(allPricesLocked: boolean, allPricesSP: boolean, winMarketLocked: boolean): HorseRaceSortingDirection {
        if (allPricesLocked || allPricesSP || winMarketLocked) {
            return HorseRaceSortingDirection.CardNumber;
        } else {
            return this.getSortingFromStorage();
        }
    }

    private getSortingFromStorage(): HorseRaceSortingDirection {
        const sortingDirection = this.m2LocalStore.get('horse-racing-sort-direction') as HorseRaceSortingDirection;
        if (sortingDirection !== HorseRaceSortingDirection.Odds && sortingDirection !== HorseRaceSortingDirection.CardNumber) {
            this.m2LocalStore.set('horse-racing-sort-direction', HorseRaceSortingDirection.CardNumber);

            return HorseRaceSortingDirection.CardNumber;
        }

        return sortingDirection;
    }

    favoriteSortingWeight(participant: WinGameParticipant): number {
        if (participant.properties!.type === ParticipantType.Favourite) {
            return Number(participant.participantId);
        }

        return 0;
    }
}
